import React from 'react'
import injectJss from 'react-jss'
import compose from 'recompose/compose'

const style = theme => ({
    dot: {
        backgroundColor: 'white',
        transition: '0.3s',
        willChange: 'opacity',
        opacity: ({ active }) => (active ? 1 : 0.4),
        width: 8,
        height: 8,
        borderRadius: '50%',
        margin: '0px 4px',
    },
})

const Dot = ({ classes }) => <div className={classes.dot} />

export default compose(injectJss(style))(Dot)
